module.exports = __webpack_public_path__ + "static/media/pro-3.114260eb.png";